export interface PresentationSettings {
  showCurrentConditions: boolean;
  showSlopeTrace: boolean;
  showRunLevelGraph: boolean;
  showRunLevelTitles: boolean;
}

export const PRESENTATION_SETTINGS_KEY = 'whiteoutPresentationSettings';

export const DEFAULT_PRESENTATION_SETTINGS: PresentationSettings = {
  // Start with only the run-level graph; saved player choices take precedence.
  showCurrentConditions: false,
  showSlopeTrace: false,
  showRunLevelGraph: true,
  showRunLevelTitles: false,
};

export function loadPresentationSettings(storage: Pick<Storage, 'getItem'> = localStorage): PresentationSettings {
  try {
    const saved = JSON.parse(storage.getItem(PRESENTATION_SETTINGS_KEY) ?? '{}');
    if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return { ...DEFAULT_PRESENTATION_SETTINGS };
    return {
      showCurrentConditions: typeof saved.showCurrentConditions === 'boolean' ? saved.showCurrentConditions : DEFAULT_PRESENTATION_SETTINGS.showCurrentConditions,
      showSlopeTrace: typeof saved.showSlopeTrace === 'boolean' ? saved.showSlopeTrace : DEFAULT_PRESENTATION_SETTINGS.showSlopeTrace,
      showRunLevelGraph: typeof saved.showRunLevelGraph === 'boolean' ? saved.showRunLevelGraph : DEFAULT_PRESENTATION_SETTINGS.showRunLevelGraph,
      showRunLevelTitles: typeof saved.showRunLevelTitles === 'boolean' ? saved.showRunLevelTitles : DEFAULT_PRESENTATION_SETTINGS.showRunLevelTitles,
    };
  } catch {
    return { ...DEFAULT_PRESENTATION_SETTINGS };
  }
}

export function savePresentationSettings(settings: PresentationSettings, storage: Pick<Storage, 'setItem'> = localStorage) {
  try { storage.setItem(PRESENTATION_SETTINGS_KEY, JSON.stringify(settings)); }
  catch { /* Display controls still work when browser storage is unavailable. */ }
}
